// extracted by mini-css-extract-plugin
export default {"searchForm":"SearchForm_searchForm__gZmgQ"};